var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettleBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.728,
    height: 21.656,
    viewBox: "0 0 22.728 21.656",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_54",
    "data-name": "Grupo 54",
    transform: "translate(-1198.346 -3292.055)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_19",
    "data-name": "Rect\\xE1ngulo 19",
    width: 12.65,
    height: 12.65,
    transform: "translate(1207.924 3300.561)",
    fill: "#e89e9e",
    stroke: "#e89e9e",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_18",
    "data-name": "Rect\\xE1ngulo 18",
    width: 12.65,
    height: 12.65,
    transform: "translate(1203.385 3296.558)",
    fill: "#3b3836",
    stroke: "#e89e9e",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_17",
    "data-name": "Rect\\xE1ngulo 17",
    width: 12.65,
    height: 12.65,
    transform: "translate(1198.846 3292.555)",
    fill: "#3b3836",
    stroke: "#e89e9e",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettleBack);
export default __webpack_public_path__ + "static/media/SETTLE_BACK.7c7b57e3.svg";
export { ForwardRef as ReactComponent };